(() => {
  'use strict';

  const ROOT_SELECTOR =
    '[data-mooa-product-recommendations]';

  const CARD_SELECTOR =
    '[data-mooa-product-recommendation]';

  const CART_ENDPOINT =
    `${window.Shopify?.routes?.root || '/'}cart.js`;

  const MAX_PROMOTED = 1;

  let cartProductIds = new Set();


  /* =========================================================
     UTILIDADES
     ========================================================= */

  function shuffle(items) {
    const result = [...items];

    for (
      let i = result.length - 1;
      i > 0;
      i -= 1
    ) {
      const j = Math.floor(
        Math.random() * (i + 1)
      );

      [
        result[i],
        result[j]
      ] = [
        result[j],
        result[i]
      ];
    }

    return result;
  }


  function uniqueByProduct(cards) {
    const seen = new Set();

    return cards.filter((card) => {
      const id =
        String(
          card.dataset.productId || ''
        );

      if (
        !id ||
        seen.has(id)
      ) {
        return false;
      }

      seen.add(id);

      return true;
    });
  }


  function getValidCandidates(
    cards,
    selectedIds
  ) {

    return uniqueByProduct(cards)
      .filter((card) => {

        const id =
          String(
            card.dataset.productId || ''
          );

        return (
          id &&
          !selectedIds.has(id) &&
          !cartProductIds.has(id)
        );

      });

  }


  /* =========================================================
     CARRITO ACTUAL
     ========================================================= */

  async function refreshCartProductIds() {
    try {

      const response =
        await fetch(
          CART_ENDPOINT,
          {
            credentials: 'same-origin',

            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {
        return;
      }


      const cart =
        await response.json();


      cartProductIds =
        new Set(
          (cart.items || [])
            .map((item) =>
              String(item.product_id)
            )
        );


    } catch (error) {

      console.warn(
        '[MööA] No se pudo leer el carrito:',
        error
      );

    }
  }


  /* =========================================================
     AÑADIR CANDIDATO
     ========================================================= */

  function addCandidate(
    card,
    selected,
    selectedIds,
    selectedFamilies,
    maxProducts
  ) {

    if (
      !card ||
      selected.length >= maxProducts
    ) {
      return false;
    }


    const id =
      String(
        card.dataset.productId || ''
      );


    if (
      !id ||
      selectedIds.has(id) ||
      cartProductIds.has(id)
    ) {
      return false;
    }


    selected.push(card);

    selectedIds.add(id);


    const family =
      card.dataset.family || '';


    if (family) {
      selectedFamilies.add(family);
    }


    return true;
  }


  /* =========================================================
     SELECCIÓN SIN REPETIR FAMILIA
     ========================================================= */

  function chooseDistinctFamilies(
    candidates,
    selected,
    selectedIds,
    selectedFamilies,
    currentFamily,
    maxProducts
  ) {

    const available =
      shuffle(
        getValidCandidates(
          candidates,
          selectedIds
        )
      );


    /*
     * PRIMERA PASADA
     *
     * Familia:
     * - diferente del producto actual
     * - todavía no utilizada
     */

    available.forEach((card) => {

      if (
        selected.length >= maxProducts
      ) {
        return;
      }


      const family =
        card.dataset.family || '';


      if (
        !family ||
        family === currentFamily ||
        selectedFamilies.has(family)
      ) {
        return;
      }


      addCandidate(
        card,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    });


    /*
     * SEGUNDA PASADA
     *
     * Permitimos la misma familia que
     * el producto actual, pero seguimos
     * sin repetir familias entre
     * recomendaciones.
     */

    available.forEach((card) => {

      if (
        selected.length >= maxProducts
      ) {
        return;
      }


      const family =
        card.dataset.family || '';


      if (
        !family ||
        selectedFamilies.has(family)
      ) {
        return;
      }


      addCandidate(
        card,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    });

  }


  /* =========================================================
     ÚLTIMO RECURSO
     PERMITIR REPETIR FAMILIA
     ========================================================= */

  function fillRemaining(
    candidates,
    selected,
    selectedIds,
    selectedFamilies,
    maxProducts
  ) {

    const available =
      shuffle(
        getValidCandidates(
          candidates,
          selectedIds
        )
      );


    available.forEach((card) => {

      if (
        selected.length >= maxProducts
      ) {
        return;
      }


      addCandidate(
        card,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    });

  }


  /* =========================================================
     INICIALIZACIÓN DE RECOMENDACIONES
     ========================================================= */

  function initialiseRecommendations(
    root
  ) {

    if (
      !(root instanceof HTMLElement)
    ) {
      return;
    }


    const allCards =
      Array.from(
        root.querySelectorAll(
          CARD_SELECTOR
        )
      );


    /*
     * Ocultamos inicialmente todas.
     */

    allCards.forEach((card) => {
      card.hidden = true;
    });


    const maxProducts =
      Math.max(
        1,
        Number(
          root.dataset.maxProducts || 3
        )
      );


    const currentFamily =
      root.dataset.currentFamily || '';


    const currentProductId =
      String(
        root.dataset
          .currentProductId || ''
      );


    const selected = [];

    const selectedIds =
      new Set([
        currentProductId
      ]);

    const selectedFamilies =
      new Set();


    /* =====================================================
       CANDIDATOS POR PRIORIDAD
       ===================================================== */

    const promoted =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 0
      );


    const manual =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 1
      );


    const history =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 2
      );


    const collection =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 3
      );


    /* =====================================================
       PRIORIDAD 0
       PROMOCIÓN

       Escogemos máximo UN producto aleatorio.
       ===================================================== */

    const availablePromoted =
      shuffle(
        getValidCandidates(
          promoted,
          selectedIds
        )
      );


    availablePromoted
      .slice(
        0,
        MAX_PROMOTED
      )
      .forEach((card) => {

        addCandidate(
          card,
          selected,
          selectedIds,
          selectedFamilies,
          maxProducts
        );

      });


    /* =====================================================
       PRIMERA FASE

       Intentamos completar las recomendaciones
       SIN REPETIR FAMILIA.

       Orden:
       1 = Complementa con
       2 = Historia
       3 = Colección
       ===================================================== */


    chooseDistinctFamilies(
      manual,
      selected,
      selectedIds,
      selectedFamilies,
      currentFamily,
      maxProducts
    );


    if (
      selected.length <
      maxProducts
    ) {

      chooseDistinctFamilies(
        history,
        selected,
        selectedIds,
        selectedFamilies,
        currentFamily,
        maxProducts
      );

    }


    if (
      selected.length <
      maxProducts
    ) {

      chooseDistinctFamilies(
        collection,
        selected,
        selectedIds,
        selectedFamilies,
        currentFamily,
        maxProducts
      );

    }


    /* =====================================================
       SEGUNDA FASE — ÚLTIMO RECURSO

       Si todavía no tenemos suficientes productos,
       permitimos repetir familia.

       Mantenemos el orden de prioridad:

       1 = Complementa con
       2 = Historia
       3 = Colección
       ===================================================== */


    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        manual,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        history,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        collection,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    /*
     * Mostramos únicamente
     * las seleccionadas.
     */

    selected.forEach((card) => {
      card.hidden = false;
    });


    root.hidden =
      selected.length === 0;

  }


  function initialiseAllRecommendations() {

    document
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(
        initialiseRecommendations
      );

  }


  /* =========================================================
     AÑADIR AL CARRITO
     ========================================================= */

  async function addVariant(
    button
  ) {

    const card =
      button.closest(
        CARD_SELECTOR
      );


    if (!card) {
      return;
    }


    const selector =
      card.querySelector(
        '[data-mooa-rec-variant]'
      );


    const variantId =
      button.dataset.variantId ||
      selector?.value ||
      '';


    if (!variantId) {
      return;
    }


    const productId =
      String(
        card.dataset.productId || ''
      );


    const originalText =
      button.textContent.trim();


    button.disabled = true;

    button.textContent =
      'Añadiendo…';


    document.dispatchEvent(
      new CustomEvent(
        'theme:loading:start'
      )
    );


    try {

      const response =
        await fetch(
          (
            window.routes
              ?.cartAddUrl ||
            '/cart/add'
          ) + '.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      Number(
                        variantId
                      ),

                    quantity: 1
                  }
                ]
              })
          }
        );


      document.dispatchEvent(
        new CustomEvent(
          'theme:loading:end'
        )
      );


      if (!response.ok) {

        const error =
          await response
            .json()
            .catch(
              () => ({})
            );


        throw new Error(
          error.description ||
          'No se pudo añadir'
        );

      }


      /*
       * Registramos inmediatamente
       * este producto como presente
       * en carrito.
       */

      if (productId) {

        cartProductIds.add(
          productId
        );

      }


      button.textContent =
        'Añadido ✓';


      /*
       * Prestige:
       * actualiza y abre carrito lateral.
       */

      document.dispatchEvent(
        new CustomEvent(
          'product:added',
          {
            bubbles: true,

            detail: {

              variant: {
                id:
                  Number(
                    variantId
                  )
              },

              quantity: 1

            }
          }
        )
      );


      /*
       * Recalculamos inmediatamente
       * las recomendaciones.

       * El producto recién añadido
       * desaparece y entra el siguiente
       * candidato disponible.
       */

      window.setTimeout(
        () => {

          initialiseAllRecommendations();

        },
        120
      );


      window.setTimeout(
        () => {

          if (
            !document.body
              .contains(button)
          ) {
            return;
          }


          button.disabled =
            false;

          button.textContent =
            originalText;

        },
        1200
      );


    } catch (error) {


      document.dispatchEvent(
        new CustomEvent(
          'theme:loading:end'
        )
      );


      button.textContent =
        /stock|sold|available/i
          .test(
            error.message
          )
          ? 'Sin stock'
          : 'Reintentar';


      window.setTimeout(
        () => {

          if (
            !document.body
              .contains(button)
          ) {
            return;
          }


          button.disabled =
            false;

          button.textContent =
            originalText;

        },
        1800
      );

    }

  }


  /* =========================================================
     EVENTOS
     ========================================================= */

  function handleClick(
    event
  ) {

    const button =
      event.target.closest(
        '[data-mooa-rec-add]'
      );


    if (!button) {
      return;
    }


    event.preventDefault();


    addVariant(
      button
    );

  }


  /*
   * Si el carrito cambia por cualquier
   * otro sitio de la web, volvemos
   * a consultar su contenido.
   */

  async function handleProductAdded() {

    await refreshCartProductIds();

    initialiseAllRecommendations();

  }


  /* =========================================================
     START
     ========================================================= */

  async function start() {

    /*
     * Antes de mostrar recomendaciones,
     * leemos qué productos están ya
     * en el carrito.
     */

    await refreshCartProductIds();


    initialiseAllRecommendations();


    document.addEventListener(
      'click',
      handleClick
    );


    document.addEventListener(
      'product:added',
      handleProductAdded
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );

  } else {

    start();

  }

})();